import React, { useState } from 'react';
import { Radio } from 'antd';
import { Container, Content, Description, Option, RadioWrapper, Title } from './styles';
import { useEffect } from 'react';
import { DESIGN_AREA_SETTINGS_TAB } from '../../SidebarMenu/translationValues';
import { useTranslation } from 'react-i18next';

const NAMESPACES = ['DESIGN_AREA_SETTINGS_TAB'];

const PdfQualitySelection = ({selectedQuality, onChange}) => {
  
  const { t } = useTranslation(NAMESPACES);

  const profiles = [
  {
    value: 0,
    title: t(DESIGN_AREA_SETTINGS_TAB.DIGITAL_TITLE.key, DESIGN_AREA_SETTINGS_TAB.DIGITAL_TITLE.value),
    description: t(DESIGN_AREA_SETTINGS_TAB.DIGITAL_DESC.key, DESIGN_AREA_SETTINGS_TAB.DIGITAL_DESC.value),
  },
  {
    value: 1,
    title: t(DESIGN_AREA_SETTINGS_TAB.PRINT_RGB_TITLE.key, DESIGN_AREA_SETTINGS_TAB.PRINT_RGB_TITLE.value),
    description: t(DESIGN_AREA_SETTINGS_TAB.PRINT_RGB_DESC.key, DESIGN_AREA_SETTINGS_TAB.PRINT_RGB_DESC.value),
  },
  {
    value: 2,
    title: t(DESIGN_AREA_SETTINGS_TAB.PRINT_CMYK_TITLE.key, DESIGN_AREA_SETTINGS_TAB.PRINT_CMYK_TITLE.value),
    description: t(DESIGN_AREA_SETTINGS_TAB.PRINT_CMYK_DESC.key, DESIGN_AREA_SETTINGS_TAB.PRINT_CMYK_DESC.value),
  },
];

  const [selected, setSelected] = useState(selectedQuality);

   const handleChange = (value) => {
       if (onChange) {
           onChange(value);
        }
    };
    
    useEffect(() => {
        setSelected(selectedQuality);
    }, [selectedQuality])
  

  return (
    <Container>
      <Radio.Group
        value={selected}
        style={{ width: '100%' }}
      >
        {profiles.map((profile) => (
          <Option key={profile.value} selected={selected === profile.value} onClick={() => handleChange(profile.value)}>
            <RadioWrapper>
              <Radio value={profile.value} />
            </RadioWrapper>
            <Content>
              <Title>{profile.title}</Title>
              <Description>{profile.description}</Description>
            </Content>
          </Option>
        ))}
      </Radio.Group>
    </Container>
  );
};

export default PdfQualitySelection;
